export default "__VITE_ASSET__D95eG$e___"